import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "text-xs" }
const _hoisted_2 = { class: "text-xs" }
const _hoisted_3 = { class: "text-xs" }

import { HolidayPayObligationEntry } from '@/types';
    import { HoverCardContent, HoverCardPortal, HoverCardRoot, HoverCardTrigger } from 'reka-ui';
    import DataTableCurrency from '@/components/datatable/DataTableCurrency.vue';
    import { formatCurrency } from '@/utils/helpers';
    import { useI18n } from 'vue-i18n';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObligationCalculationHoverCard',
  props: {
    value: {},
    holidayPayObligationEntry: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    

return (_ctx: any,_cache: any) => {
  return (!_ctx.holidayPayObligationEntry.calculator)
    ? (_openBlock(), _createBlock(DataTableCurrency, {
        key: 0,
        value: _ctx.value,
        "return-zero": true
      }, null, 8, ["value"]))
    : (_openBlock(), _createBlock(_unref(HoverCardRoot), {
        key: 1,
        "close-delay": 0,
        "open-delay": 200
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(HoverCardTrigger), null, {
            default: _withCtx(() => [
              _createVNode(DataTableCurrency, {
                value: _ctx.value,
                "return-zero": true
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_unref(HoverCardPortal), null, {
            default: _withCtx(() => [
              _createVNode(_unref(HoverCardContent), {
                class: "animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 flex flex-col gap-1 rounded-xl border bg-white p-4 shadow-sm data-[state=open]:transition-all",
                "side-offset": 5
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(formatCurrency)(_ctx.holidayPayObligationEntry.calculator.obligation.basic_salary)) + " " + _toDisplayString(_unref(t)('holiday-pay-obligations.entries.tooltip.obligation.basic_salary')), 1),
                  _createElementVNode("span", _hoisted_2, " / " + _toDisplayString(_unref(formatCurrency)(_ctx.holidayPayObligationEntry.calculator.obligation.work_days)) + " " + _toDisplayString(_unref(t)('holiday-pay-obligations.entries.tooltip.obligation.work_days')), 1),
                  _createElementVNode("span", _hoisted_3, " * " + _toDisplayString(_unref(formatCurrency)(
                            Number(
                                _ctx.holidayPayObligationEntry.calculator.obligation.days_outstanding,
                            ),
                        )) + " " + _toDisplayString(_unref(t)('holiday-pay-obligations.entries.tooltip.obligation.days_outstanding')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
}
}

})